const getEnvConfig = (item = "apiV1Url") => {
  const url = localStorage.getItem(item);
  if (url && url !== "undefined") {
    return Promise.resolve(url);
  }

  return fetch(process.env.PUBLIC_URL + "/config.json")
    .then(response => response.json())
    .then(data => {
      localStorage.setItem(item, data[item]);

      return data[item];
    })
    .catch(err => {
      console.error(`Error reading environment config: ${err}`);
    });
};

export { getEnvConfig };
